import Dexie from 'dexie';
import path from 'path';

import { SpaceTag } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import {
  ConflictStrategy,
  CoSyncStrategy,
  CoSyncTimingType,
  KeepWhichLastStatus,
} from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';

export interface ICoSyncInfoDAOData {
  localSyncId: number;
  remoteSyncId: number;
  userId: number;
  orgId: number;
  spaceId: string;
  spaceTag: SpaceTag;
  spaceOrgId: number;
  teamId: number;
  teamPath: string;
  isCreateBaseLocal: boolean;
  strategy: CoSyncStrategy;
  timingType: CoSyncTimingType;
  conflictStrategy: ConflictStrategy;
  keepWhichLastStatus: KeepWhichLastStatus;
  localPath: string;
  remotePath: string;
  ignoreList?: string[]; // 目录级排除清单（仅本地生效；非索引字段，无需升级 schema）
}

export interface IMigration {
  purpose: string;
  timestampInMs: number;
  needMigration: boolean;
}

let coSyncDexie: Dexie | null = null;

export function getCoSyncDB() {
  let a_dexie: Dexie | null = null;

  if (coSyncDexie) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    a_dexie = coSyncDexie!;
  } else {
    a_dexie = new Dexie('CoSyncDB');
    a_dexie.version(4).stores({
      config: 'localSyncId,userId,orgId,[userId+orgId]',
    });
    a_dexie
      .version(8)
      .stores({
        config: 'localSyncId,userId,orgId,[userId+orgId]',
      })
      .upgrade(tx => {
        return tx.table('config').clear();
      });

    a_dexie.version(9).stores({
      config: 'localSyncId,userId,orgId,[userId+orgId]',
      migration: 'purpose',
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const dexie = a_dexie!;
  coSyncDexie = dexie;

  return {
    dexie,
    config: dexie.table<ICoSyncInfoDAOData, number>('config'),
    migration: dexie.table<IMigration, number>('migration'),
  };
}

export type CoSyncDB = ReturnType<typeof getCoSyncDB>;
